var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30 9H0M22 1l8 8-8 8","stroke":"currentColor"}));
}

Arrow.defaultProps = {"width":"31","height":"18","viewBox":"0 0 31 18","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
